export default __webpack_public_path__ + "static/media/Group 351.ab54f36e.png";